const normalizePoint = (point) => {
  if (!point) return null;

  const lat = Number(point.lat);
  const lng = Number(point.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return { lat, lng };
};

const pointKey = (label, point) => `${label}:${point.lat},${point.lng}`;

export const buildOpportunityMapCameraPlan = ({
  instructorLocation,
  opportunities = [],
  isLoading = false,
  defaultZoom = 12,
} = {}) => {
  if (isLoading) {
    return {
      action: 'hold',
      key: null,
      points: [],
    };
  }

  const instructorPoint = normalizePoint(instructorLocation);
  const opportunityPoints = opportunities
    .map((opportunity) => ({
      id: String(opportunity?.id || ''),
      point: normalizePoint(opportunity?.position),
    }))
    .filter((opportunity) => opportunity.id && opportunity.point)
    .sort((a, b) => a.id.localeCompare(b.id));

  if (opportunityPoints.length > 0) {
    const points = [
      ...(instructorPoint ? [instructorPoint] : []),
      ...opportunityPoints.map((opportunity) => opportunity.point),
    ];
    const keyParts = [
      'fit',
      ...(instructorPoint ? [pointKey('instructor', instructorPoint)] : []),
      ...opportunityPoints.map((opportunity) => pointKey(opportunity.id, opportunity.point)),
    ];

    return {
      action: 'fitBounds',
      key: keyParts.join('|'),
      points,
    };
  }

  if (instructorPoint) {
    return {
      action: 'center',
      key: `${pointKey('center|instructor', instructorPoint)}|zoom:${defaultZoom}`,
      center: instructorPoint,
      zoom: defaultZoom,
      points: [],
    };
  }

  return {
    action: 'hold',
    key: null,
    points: [],
  };
};
